module.exports = __webpack_public_path__ + "img/1F1E8-1F1F0.5375ac8b.svg";